// extracted by mini-css-extract-plugin
export default {"cls1":"VeloRadioTileGroup-Grid_cls1__ghESP","cls2":"VeloRadioTileGroup-Grid_cls2__6iIoN VeloRadioTileGroup-Grid_cls1__ghESP"};